import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=79ad1157&scoped=true"
import script from "./HistoryList.vue?vue&type=script&lang=js"
export * from "./HistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad1157",
  null
  
)

export default component.exports